<template>
  <WarningBanner v-if="isNowFreezePeriod" :message="freezePeriodMessage" />
</template>

<script lang="ts">
import { FREEZE_PERIOD_MESSAGE, isFreezePeriod } from '@/utils/periods'
import { defineComponent } from 'vue'

export default defineComponent({
  setup: () => ({
    freezePeriodMessage: FREEZE_PERIOD_MESSAGE,
    isNowFreezePeriod: isFreezePeriod(),
  }),
})
</script>
